module.exports = __webpack_public_path__ + "static/media/Antharas.68f5fa10.png";